import baseConfig, { type ThemeData } from '@/../config/themes';
import acronisSelfServiceLogo from '@/assets/images/acronis/acronis-logo-ss.svg';
import acronisSelfServiceLoginLogo from '@/assets/images/acronis/acronis-login-logo-ss.svg';
import acronisSelfServiceFavicon from '@/assets/images/acronis/favicon.png';
import acronisS3Bg from '@/assets/images/acronis/s3-cloud.svg';

import virtuozzoLogo from '@/assets/images/virtuozzo/virtuozzo-logo-ss.svg';
import virtuozzoLoginLogo from '@/assets/images/virtuozzo/virtuozzo-login-logo-ss.svg';
import virtuozzoFavicon from '@/assets/images/virtuozzo/favicon.ico';
import virtuozzoS3Bg from '@/assets/images/virtuozzo/s3-cloud.svg';

import schemes from '@uikit/ui-syntax/dist/js/colors';

export type SelfServiceThemeData = ThemeData & {
  logo: string;
  loginLogo: string;
  logoIcon: string;
  favicon: string;
  docsLink: string;
  supportLink: string;
  s3Bg: string;
  cssVariables: Record<string, string>;
}

const selfServiceThemes: Record<typeof APP_THEME, SelfServiceThemeData> = {
  acronis: {
    ...baseConfig.acronis,
    logo: acronisSelfServiceLogo,
    loginLogo: acronisSelfServiceLoginLogo,
    logoIcon: 'i-a-logo--32',
    favicon: acronisSelfServiceFavicon,
    docsLink: 'https://www.acronis.com/support/documentation/',
    supportLink: 'https://www.acronis.com/support',
    cssVariables: schemes.DefaultColorScheme,
    s3Bg: acronisS3Bg
  },
  virtuozzo: {
    ...baseConfig.virtuozzo,
    logo: virtuozzoLogo,
    loginLogo: virtuozzoLoginLogo,
    logoIcon: 'i-v-logo--32',
    favicon: virtuozzoFavicon,
    docsLink: 'https://docs.virtuozzo.com/master/index.html',
    supportLink: 'https://support.virtuozzo.com',
    cssVariables: schemes.VirtuozzoColorScheme,
    s3Bg: virtuozzoS3Bg
  },
  'vz-converted': {
    ...baseConfig.acronis,
    logo: acronisSelfServiceLogo,
    loginLogo: acronisSelfServiceLoginLogo,
    logoIcon: 'i-a-logo--32',
    favicon: acronisSelfServiceFavicon,
    docsLink: 'https://www.acronis.com/support/documentation/',
    supportLink: 'https://www.acronis.com/support',
    cssVariables: schemes.DefaultColorScheme,
    s3Bg: acronisS3Bg
  }
};

export default selfServiceThemes;
